import _ from 'underscore'
import Backbone from 'backbone'
import Logger from 'Logger'

var PopupModel = Backbone.Model.extend({
  initialize: function () {
    _.bindAll(this, 'hide')
  },

  defaults: function () {
    return {
      template: 'message', // message | confirm
      title: '안내',
      message: '',
      detail: '',
      detailImgUrl: '',
      popupClass: '', // 디자인 변경 하고 싶으면 클래스 네임 넣자
      classDetail: '', // 개월권 상세 정보 detail.monthly.js
      onConfirm: _.noop(),
      onCancel: _.noop(),
      onClose: this.hide,
      confirmText: null,
      cancelText: null,
      closeText: '닫기',
      confirmBtnColor: 'gray', //  string: gray | red
      cancelBtnColor: 'red', //  string: gray | red
      closeBtnColor: '', //  string: gray | red
      isVisible: false,
      // 구매 완료 팝업
      hasfailGoods: false,
      successGoodsName: null,
      failGoodsName: null,
      // 클래스 구매한도 초과 안내
      classMoney: 0,
      dailyMoney: 0,

      // ViewModel : any type. 템플릿에서 알아서 처리. 아무 데이터나 넘길때, vipCoupons에서 씀
      vm: null,
    }
  },
  show: function (options) {
    var combineOptions = _.extend(options, {
      isVisible: true,
    })
    this.set(combineOptions)
    Logger.info('Popup Show', this.toJSON())
  },
  hide: function () {
    Logger.info('Popup hide')
    this.set(this.defaults())
  },
  parse: function (data) {
    var parsed = _.extend(data, {})
    return parsed
  },
})

export var popupModel = new PopupModel()
